import { TrackEvent } from '@bnnvara/analytics';
/* eslint-disable react/jsx-no-target-blank */
import PropTypes from 'prop-types';
import React from 'react';

import * as S from './styled';

const NPOVideoPlayer = ({ embedId, title, isBroadcastEnabled, ...props }) => {
  if (isBroadcastEnabled) {
    return (
      <iframe
        src={`https://start-player.npo.nl/embed/${embedId}`}
        title={title}
        width="100%"
        height="100%"
        frameBorder="0"
        scrolling="no"
        allowFullScreen
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allow="encrypted-media"
        {...props}
      />
    );
  }
  return (
    <S.NPOLink>
      Bekijk deze uitzending op &nbsp;
      <a
        href="https://www.npostart.nl"
        target="_blank"
        rel="noopener"
        onClick={() => TrackEvent('videoplayer-npo-pip', 'click', 'NPO Start')}
      >
        NPO Start
      </a>
    </S.NPOLink>
  );
};

NPOVideoPlayer.propTypes = {
  title: PropTypes.string.isRequired,
  embedId: PropTypes.string.isRequired,
  isBroadcastEnabled: PropTypes.bool.isRequired,
};

export default NPOVideoPlayer;
